import { Box, Container, Typography, Button, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { HeroSection } from '../../components/marketing/HeroSection';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const includedFeatures = [
  {
    title: 'Primary Dedicated Assistant',
    description:
      "We provide a dedicated assistant who will be your point of contact for all your requests. Our assistants are experienced U.S.-based employees of Fancy Hands, not gig workers. You'll work with the same assistant consistently, allowing them to gain an understanding of your needs and preferences.",
  },
  {
    title: 'Secondary Dedicated Assistant',
    description:
      'We also provide a secondary dedicated assistant who will serve as your backup and extra hands. They too are experienced U.S.-based employees of Fancy Hands and can jump in to help whenever needed.',
  },
  {
    title: 'Support Team Leader',
    description:
      'We have a U.S.-based employee of Fancy Hands who is available to assist with any account and billing support needs regarding your service. They will ensure that any issues are addressed promptly and effectively.',
  },
  {
    title: 'Weekly Usage Reports',
    description:
      'We provide weekly usage reports to help you understand where and when your time is being spent. This will enable you to track your progress and optimize your time management strategies.',
  },
  {
    title: 'Inbox Management',
    description:
      "Let us handle your email inbox. We will track and notify you of important emails so that you don't miss anything and don't have to comb through an over-cluttered inbox.",
  },
  {
    title: 'Light Bookkeeping',
    description:
      'Our assistants can handle invoicing, expense reporting, and receipt tracking for you. This will help you stay organized and save time.',
  },
  {
    title: 'Digital File/Document Organization',
    description:
      'We can organize your digital files and documents in a neat file management system of your choice, such as Box.com or Google Drive. This will ensure that your files are easy to find and manage.',
  },
  {
    title: 'Purchases',
    description:
      'Let our assistants handle the purchasing of goods and services for you. This will save you time and ensure that everything is ordered correctly.',
  },
  {
    title: 'Schedule/Calendar Management',
    description:
      "Our assistants can help you get important meetings scheduled and send reminders to ensure that you don't miss anything.",
  },
  {
    title: 'Vendor/Contractor Research',
    description:
      'If you need specialized vendors or contractors, we can help find one for you.',
  },
  {
    title: 'CRM Maintenance',
    description:
      "We can manage and organize existing and new contacts in your database/CRM. This will help you stay organized and ensure that you don't miss any opportunities.",
  },
  {
    title: 'Setup Communication & Project Management Channels',
    description:
      'Our assistants can optimize communication and task/project workflows between you and your assistant. This will ensure that everything runs smoothly and efficiently.',
  },
  {
    title: 'Vendor Management',
    description:
      'We can track vendor work and ensure that vendors are paid on time.',
  },
  {
    title: 'Weekly Update Calls',
    description:
      'We provide weekly check-ins for any task/project updates and brainstorming sessions. You will have someone to listen to your thoughts and provide feedback.',
  },
  {
    title: 'Confidentiality of Information',
    description:
      'Our assistants can sign an NDA directly with you to ensure the confidentiality of your information.',
  },
];

export const DedicatedIncludedPage = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <HeroSection
        title="What's Included?"
        subtitle="Fancy Hands provides real, US-based personal assistants to help people (and businesses) manage their day-to-day tasks more efficiently. Here's a breakdown of what's included in our dedicated service."
        variant="gradient"
      />

      <Container maxWidth="md" sx={{ py: { xs: 4, md: 8 } }}>
        <List sx={{ '& .MuiListItem-root': { alignItems: 'flex-start', py: 2 } }}>
          {includedFeatures.map((feature, index) => (
            <ListItem key={index} sx={{ borderBottom: '1px solid', borderColor: 'divider' }}>
              <ListItemIcon sx={{ mt: 0.5 }}>
                <CheckCircleIcon sx={{ color: 'success.main' }} />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography variant="subtitle1" fontWeight={600}>
                    {feature.title}
                  </Typography>
                }
                secondary={
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                    {feature.description}
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>

        <Box sx={{ textAlign: 'center', mt: 6 }}>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/dedicated-assistant')}
          >
            Learn More About Dedicated Assistants
          </Button>
        </Box>
      </Container>
    </Box>
  );
};
